import { Form, InputGroup } from "react-bootstrap";
import { Search } from "react-bootstrap-icons";

export default function SearchInput({ filterData, setFilterData, placeholder = "Search by artist, title or release year" }) {
    return (
        <InputGroup>
            <InputGroup.Text className="input-icon">
                <Search />
            </InputGroup.Text>
            <Form.Control
                value={filterData.searchString}
                onChange={e => setFilterData({ ...filterData, searchString: e.target.value })}
                placeholder={placeholder}
            />
        </InputGroup>
    );
}
